var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComputer1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "computer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.55 3.67555C21.2 3.16555 20.76 2.73555 20.26 2.38555C18.91 1.43555 17.18 1.43555 13.75 1.43555H9.75C6.32 1.43555 4.59 1.43555 3.24 2.38555C2.74 2.73555 2.3 3.17555 1.95 3.67555C1 5.02555 1 6.75555 1 10.1855C1 13.6155 1 15.3455 1.95 16.6955C2.3 17.1955 2.74 17.6355 3.24 17.9855C4.55 18.9055 6.21 18.9355 9.44 18.9355C9.6 19.7755 9.43 20.6955 8.97 21.3155L8.88 21.4355H6.75C6.34 21.4355 6 21.7755 6 22.1855C6 22.5955 6.34 22.9355 6.75 22.9355H16.75C17.16 22.9355 17.5 22.5955 17.5 22.1855C17.5 21.7755 17.16 21.4355 16.75 21.4355H14.62L14.53 21.3155C14.07 20.6955 13.9 19.7755 14.06 18.9355C17.29 18.9355 18.95 18.9055 20.26 17.9855C20.76 17.6355 21.2 17.2055 21.55 16.6955C22.5 15.3455 22.5 13.6155 22.5 10.1855C22.5 6.75555 22.5 5.02555 21.55 3.67555ZM10.61 21.4355C10.95 20.6755 11.07 19.7855 10.96 18.9355H12.55C12.43 19.7955 12.55 20.6755 12.88 21.4355H10.61ZM12.75 15.9355H10.75C10.34 15.9355 10 15.5955 10 15.1855C10 14.7755 10.34 14.4355 10.75 14.4355H12.75C13.16 14.4355 13.5 14.7755 13.5 15.1855C13.5 15.5955 13.16 15.9355 12.75 15.9355Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComputer1);
export default __webpack_public_path__ + "static/media/computer1.a0b04a8fca643814d6f6f1eba0c5ae4a.svg";
export { ForwardRef as ReactComponent };